import { AxiosResponse } from 'axios';
import { useMutation } from 'react-query';

// components
import { errorToast } from 'components/toasts/error';
// configs
import { API } from 'configs/api';
// utils
import { getShortUrlFromUrl } from 'utils/url';
//types
import { EventDetails } from './types';

const createUserCalendarEventMutation = async ({
  data,
}: {
  data: EventDetails;
}) => {
  const shortUrl = getShortUrlFromUrl();
  if (!shortUrl) {
    throw new Error('Invalid url');
  }

  const response: AxiosResponse = await API.post(
    `/playback/${shortUrl}/event`,
    data
  );

  return response.data;
};

export const useCreateUserCalendarEventMutation = () => {
  return useMutation(createUserCalendarEventMutation, {
    onError: () => {
      errorToast({
        title:
          'There was an error scheduling your test drive, please contact your advisor!',
      });
    },
  });
};
